<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#h12bu7tfca)">
            <path
                d="M9.205 5.793 4.208.79C3.818.4 3.18.4 2.79.79a1.01 1.01 0 0 0 0 1.42l4.287 4.293-4.287 4.293a.997.997 0 0 0 .71 1.701c.26 0 .51-.1.71-.29l4.996-5.003a.997.997 0 0 0 0-1.411z"
            />
        </g>
        <defs>
            <clipPath id="h12bu7tfca">
                <path transform="translate(0 .5)" d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>

<style lang="scss" scoped>
svg {
    //fill: var(--on-surface);
    overflow: visible;
}
</style>
